// ./gatsby-browser.js
import './src/styles/global.css';


import injectDoko from "./inject-doko"
export const wrapRootElement = injectDoko